import React from "react"
import GridContainer from "@/components/common/GridContainer"
import TextWrapper from "@/components/common/StructuredText/common/TextWrapper"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import { ImageWrapper } from "@/components/common/StructuredText/components/Block"
import { getAspectRatioFromImage, getMarginsData } from "@/utils/utils"
import { colors } from "@/styles/themeSettings"
import styled from "styled-components"
import { formatImageCMSData } from "@/components/common/Image"
import DynamicMargin from "@/components/common/DynamicMargin"
import Image from "@/components/common/Image"

// const Image = dynamic(() => import("@/components/common/Image"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 32,
		TABLET: 64,
		DESKTOP: 64,
	},
	BOTTOM: {
		MOBILE: 32,
		TABLET: 64,
		DESKTOP: 64,
	},
}

const Wrapper = styled(GridContainer)``

export default function MediumImage({ data }) {
	const author = data?.image?.customData?.author || null
	const aspectRatio = getAspectRatioFromImage(data?.image)
	const imageData = formatImageCMSData(data?.image)
	const showMetaData = data?.showMetaData || false

	console.log(data)
	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<Wrapper className="indent-desktop-3">
				<TextWrapper className="col-mobile-8 col-tablet-8 col-desktop-10 no-select">
					<ImageWrapper $aspectRatio={aspectRatio} className={`${author ? "variant-author" : ""}`}>
						<Image
							src={imageData.url}
							alt={imageData.alt}
							showMetaData={showMetaData}
							metaData={imageData.metaData}
							metaDataColor={colors.richBlack}
							sizes="100%"
						/>
					</ImageWrapper>
					{author && <TextWrapper className={`typo-strawford typo-strawford-82 align-end italic`}>{author}</TextWrapper>}
				</TextWrapper>
			</Wrapper>
		</DynamicMargin>
	)
}